import React from "react";

import { RadioButtonBoxProps } from "@models/components/formElements.model";

const RadioButtonBox: React.FC<RadioButtonBoxProps> = ({
  id,
  label,
  name,
  setValue,
  value,
}) => {
  return (
    <>
      <input
        autoComplete="off"
        checked={value === name}
        className="btn-check"
        id={id}
        name={name}
        onChange={() => setValue(value)}
        type="radio"
        data-testid="radio-button-box"
      />
      <label
        className="btn btn-outline-primary"
        htmlFor={id}
        data-testid="radio-button-box-label"
      >
        {label}
      </label>
    </>
  );
};

export default RadioButtonBox;
